import { NgModule } from '@angular/core';
import { RouterModule, TitleStrategy } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WelcomeComponent } from '@connect/components/welcome/welcome.component';
import { ConnectTitleStrategyProvider } from '@connect/shared/providers/connect-title-strategy.provider';
import { ContactService } from './contact/services/contact.service';
import { LookupService } from './secure/services/lookup.service';
import { ClientService } from './contact/services/client.service';
import { BaseHttpClientService } from './shared/services/base-http-client.service';
import { routes } from './../routes/routes'

@NgModule({
    declarations: [
        WelcomeComponent
    ],
    exports: [
        RouterModule
    ],
    imports: [
        RouterModule.forRoot(routes),
        FormsModule
    ],
    providers: [
        {
            provide: TitleStrategy,
            useClass: ConnectTitleStrategyProvider
        },
        ContactService,
        LookupService,
        ClientService,
        BaseHttpClientService
    ]
})
export class AppRoutingModule {
}
